
























import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import store from "../store/index";

const githubApiUrl = "https://api.github.com/users/";

@Component({ store: store })
export default class Profile extends Vue {
  profile = {};

  mounted() {
    this.getProfileDetails();
  }
  get githubUsername() {
    return this.$store.state.githubUsername;
  }

  @Watch("githubUsername")
  getProfileDetails() {
    axios
      .get(`${githubApiUrl}${this.githubUsername}`)
      .then((response) => {
        this.profile = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
